import { createDynamicComponent } from './createDynamicComponent';
import SectionText from '@components/SectionText';
import SideBySide from '@components/SideBySide';
import ImageWrapper from '@components/ImageWrapper';
import Services from '@components/Services';

const HomeComponents = {
  ContentfulSectionText: SectionText,
  ContentfulImage: ImageWrapper,
  ContentfulSideBySide: SideBySide,
  ContentfulServices: Services,
};

export const DynamicComponents = createDynamicComponent(HomeComponents);
